import { useEffect, useState } from 'react';
import { orderBy } from 'lodash';
import { useFormContext } from 'react-hook-form';

import { TopupSorting } from '@epi-constants/topupSorting';
import { FormFields } from '@epi-forms/helpers';
import { TopupFormType } from '@epi-pages/LoadBenefit/components/Topup/TopupForm';

export const useSortEmployees = () => {
  const { watch, setValue } = useFormContext<TopupFormType>();
  const [sortBy, setSortBy] = useState(TopupSorting.ByLastName);
  const [descending, setDescending] = useState(false);

  const checkableEmployees = watch(FormFields.CheckableEmployees);

  const handleSort = (newSortBy: string) => {
    if (newSortBy === sortBy) {
      setDescending(!descending);
    } else {
      setSortBy(newSortBy);
    }
  };

  const sortEmployees = () => {
    setValue(
      FormFields.CheckableEmployees,
      orderBy(checkableEmployees, sortBy, descending ? 'desc' : 'asc')
    );
  };

  useEffect(() => {
    if (checkableEmployees.length) {
      sortEmployees();
    }
  }, [sortBy, descending]);

  return { handleSort, descending, sortBy };
};
